import { SelectConfig, Select } from 'components/atoms/inputs/Select/parts/Select'
import { useState, useMemo, useRef } from 'react'


export const useSelect = <Value extends any>(config: SelectConfig<Value>) => {
  const [, rerender] = useState({})
  const { value, options, onChange } = config

  const context = useMemo(() => {
    return new Select<Value>(config, () => rerender({}))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useMemo(() => {
    context.patchOnChange(onChange)
  }, [onChange, context])

  const valueCacheIndexRef = useRef(0)
  if (value !== context.value) {
    valueCacheIndexRef.current++
  }
  useMemo(() => {
    context.patchValue(value)
  }, [value, context])

  useMemo(() => {
    context.patchOptions(options)
    context.patchValue(context.value, { override: true })
  }, [options, context])

  return context
}
